import { useTranslation } from "react-i18next";
import { PrimaryButton } from "../Buttons/PrimaryButton";
import { SecondaryButton } from "../Buttons/SecondaryButton";
import { DialogFrame } from "../Dialogs/dialog-base";
import { CustomInput } from "../Input/CustomInput";

interface EmailDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  email: string;
  onEmailChange: (email: string) => void;
  onSubmit: () => void;
}

export default function EmailDialog({
  open,
  setOpen,
  email,
  onEmailChange,
  onSubmit,
}: EmailDialogProps) {
  const { t } = useTranslation();
  // Very rough email regex, not intended as a security feature.
  // It is only slightly better than string.contains(@) but also avoids missing tld.
  const emailIsValid = () => /.+@.+\..+/.test(email);

  const submit = () => {
    if (!emailIsValid()) return;
    onSubmit();
    setOpen(false);
  };

  return (
    <DialogFrame
      dialogOption={{
        closeDialog: () => setOpen(false),
        openDialog: () => setOpen(true),
        isOpen: open,
      }}
    >
      <h3 className="text-left text-base font-bold pb-2">
        {t("compLogoDesign.sendPreview")}
      </h3>
      <p>{t("compLogoDesign.sendPreviewInstruction")}</p>
      <CustomInput
        className="my-4"
        type="text"
        value={email}
        onChange={(e) => onEmailChange(e.target.value)}
      />
      <div className="flex flex-row gap-3 justify-between">
        <SecondaryButton onClick={() => setOpen(false)}>
          {t("cancel")}
        </SecondaryButton>
        <PrimaryButton disabled={!emailIsValid()} onClick={submit}>
          {t("compLogoDesign.sendEmail")}
        </PrimaryButton>
      </div>
    </DialogFrame>
  );
}
